import React from "react";
import Button from "@mui/material/Button";
import BasicField from "../components/BasicField";
import CircularProgress from "@mui/material/CircularProgress";

import { Field, reduxForm } from "redux-form";


const validate = values => {
  const errors = {};
  if (!values.email) {
    errors.email = "Required";
  }
  return errors;
};

const ForgotPasswordForm = ({ handleSubmit, invalid, pristine, submitting }) => {
  return (
    <form onSubmit={ handleSubmit }>

      <div className="field">
        <Field
          name="email"
          component={BasicField}
          type="text"
          spellCheck={false}
          autoComplete="username email"
          label="Email" />
      </div>

      <div>
        <Button
          type="submit"
          className="fullWidthButton"
          variant="contained" 
          color="primary"
          size="large"
          disabled={invalid || pristine || submitting}>
            {submitting ? <CircularProgress size={24} /> : "Send reset code"}
        </Button>

      </div>
    </form>
  );
};

export default reduxForm({ form: "forgotPassword", validate })(ForgotPasswordForm);